import { createActionGroup, props } from '@ngrx/store';
import { OsUpdateStatus } from './os-update-states.state';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const OsUpdateStatesResolverActions = createActionGroup({
  source: 'OS Update States Resolver',
  events: {
    'os Update State requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AppleDeviceApiActions = createActionGroup({
  source: 'Apple Device API',
  events: {
    'os Update State loaded': props<{ osUpdateStatusses: OsUpdateStatus[] }>(),
    'os Update State loaded error': props<{ error: ErrorModel }>(),
  },
});
